module.exports = __webpack_public_path__ + "img/chatNoBellIcon.ffafa832.svg";